import { cx } from '@twind/core';
import React from 'react';

type Props<T extends React.ElementType> = {
  content?: string;
  children?: React.ReactNode;
  className?: string;
  forwardRef?: React.Ref<HTMLDivElement>;
  component?: T;
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
};

export default function OstroDynamicContent({
  content,
  children,
  className,
  component: Component = 'div',
  forwardRef,
  ...props
}: Props<React.ElementType>) {
  if (content) {
    return (
      <Component
        {...props}
        ref={forwardRef}
        className={cx(
          '~([&_p]:mb-2 [&_ul]:(mb-2 pl-4) [&_ol]:(mb-2 pl-4) [&_ul_>_li]:(list-disc mb-2) [&_ol_>_li]:(list-decimal mb-2) [&_a]:(underline) text-sm [&_h1]:(text-[20px] font-semibold mb-2 leading-[26px]))',
          className
        )}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  return (
    <Component
      {...props}
      className={cx(
        '~([&_p]:mb-2 [&_ul]:(mb-2 pl-4) [&_ol]:(mb-2 pl-4) [&_ul_>_li]:(list-disc mb-2) [&_ol_>_li]:(list-decimal mb-2) [&_a]:(underline) text-sm [&_h1]:(text-[20px] font-semibold mb-2 leading-[26px]))',
        className
      )}
    >
      {children}
    </Component>
  );
}
